import type { FC } from 'react';

import PageLayoutDesktop from 'src/components/account/PageLayout/PageLayoutDesktop';
import PasswordResetConfirmContent from 'src/components/account/PasswordResetConfirmPage/components/PasswortResetConfirmContent';

const ResetConfirmPageDesktop: FC = () => (
  <PageLayoutDesktop>
    <PasswordResetConfirmContent />
  </PageLayoutDesktop>
);

export default ResetConfirmPageDesktop;
